// @flow
import { fetchCuratedCollectionData, getCuratedCollectionItemIds } from '../../../redux/modules/curatedCollection';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchItemsIfNeeded } from '../../../redux/modules/item';
import { recordAnalyticsForCuratedCollectionPageView } from '../../../redux/modules/analytics';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;

    return Promise.all([dispatch(fetchCuratedCollectionData(Number(params.collectionId)))]).then(() => {
        const currentState = getState();
        const itemIds = getCuratedCollectionItemIds(currentState);
        return Promise.all([
            dispatch(fetchItemsIfNeeded([...itemIds])),
            dispatch(recordAnalyticsForCuratedCollectionPageView()),
        ]);
    });
};
